import { useState } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";

/**
 * Galería mosaico responsive. Al hacer clic abre un lightbox modal.
 */
export default function TripGallery({ images = [], alt = "" }) {
  const [openIdx, setOpenIdx] = useState(null);
  if (!images.length) return null;

  return (
    <>
      <div
        className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3"
        data-testid="trip-gallery"
      >
        {images.map((src, i) => {
          // Primera imagen ocupa 2x2, el resto 1x1
          const isBig = i === 0;
          return (
            <motion.button
              type="button"
              key={src}
              onClick={() => setOpenIdx(i)}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-2xl bg-brand-surface aspect-[4/3] focus:outline-none focus:ring-2 focus:ring-brand-primary/40 ${
                isBig ? "md:col-span-2 md:row-span-2 md:aspect-auto" : ""
              }`}
            >
              <img
                src={src}
                alt={`${alt} — foto ${i + 1}`}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors" />
            </motion.button>
          );
        })}
      </div>

      {openIdx !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpenIdx(null)}
          role="dialog"
          aria-modal="true"
          data-testid="gallery-lightbox"
        >
          <button
            type="button"
            className="absolute top-5 right-5 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white inline-flex items-center justify-center"
            onClick={() => setOpenIdx(null)}
            aria-label="Cerrar galería"
            data-testid="gallery-close"
          >
            <X className="h-5 w-5" />
          </button>
          <img
            src={images[openIdx]}
            alt={`${alt} — foto ${openIdx + 1}`}
            className="max-h-[85vh] max-w-[95vw] rounded-xl shadow-2xl object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <div className="absolute bottom-6 inset-x-0 flex items-center justify-center gap-2">
            {images.map((_, i) => (
              <button
                type="button"
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenIdx(i);
                }}
                aria-label={`Ir a foto ${i + 1}`}
                className={`h-2 rounded-full transition-all ${
                  i === openIdx ? "bg-white w-8" : "bg-white/40 w-2 hover:bg-white/70"
                }`}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
